import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TabGroupComponent } from '../../shared/components/tabs/tab-group/tab-group.component';
import { TabComponent } from '../../shared/components/tabs/tab/tab.component';
import { ComplianceData } from '../../shared/models/compliance-data.model';
import { BASIC_IMPORTS } from '../../shared/imports/common-imports';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { RISK_FLAGS } from '../../shared/data/risk-flags';
import {
  EmptyVendorFlagsPercentages,
  VendorFlagsPercentages,
} from '../../shared/models/percentages-response.model';
import { RiskScoreService } from '../../shared/services/risk-score.service';

@Component({
  selector: 'app-compliance-element-detail',
  standalone: true,
  imports: [
    TabGroupComponent,
    TabComponent,
    BASIC_IMPORTS,
    MatTooltip,
    RouterLink,
  ],
  templateUrl: './compliance-element-detail.component.html',
  styleUrl: './compliance-element-detail.component.scss',
})
export class ComplianceElementDetailComponent implements OnChanges {
  @Input() data!: ComplianceData;
  @Input() elementName = '';
  @Input() percentageSum: VendorFlagsPercentages = {
    ...EmptyVendorFlagsPercentages,
  };

  constructor(private readonly riskScoreService: RiskScoreService) {}

  defaultProgressBars = [
    [{ value: 100, isDominant: false, color: 'gray' }],
    [{ value: 100, isDominant: false, color: 'gray' }],
    [{ value: 100, isDominant: false, color: 'gray' }],
  ];
  tabData = this.getDefaultTabData();

  //MVP validator, needs to be removed later
  isMvpValidData = true;

  riskFlags = [...RISK_FLAGS];
  isDataSumZero = false;

  isLoading = true;

  private getDefaultTabData() {
    return [
      {
        label: 'ABAC',
        color: 'green',
        progressBars: [
          [{ value: 100, isDominant: false, color: 'gray' }],
          [{ value: 100, isDominant: false, color: 'gray' }],
          [{ value: 100, isDominant: false, color: 'gray' }],
        ],
      },
      {
        label: 'Promotional Risk',
        color: 'gray',
        progressBars: [
          [{ value: 100, isDominant: false, color: 'gray' }],
          [{ value: 100, isDominant: false, color: 'gray' }],
          [{ value: 100, isDominant: false, color: 'gray' }],
        ],
      },
      {
        label: '3rd Party Risk',
        color: 'gray',
        progressBars: [
          [{ value: 100, isDominant: false, color: 'gray' }],
          [{ value: 100, isDominant: false, color: 'gray' }],
          [{ value: 100, isDominant: false, color: 'gray' }],
        ],
      },
      {
        label: 'Data Management',
        color: 'gray',
        progressBars: [
          [{ value: 100, isDominant: false, color: 'gray' }],
          [{ value: 100, isDominant: false, color: 'gray' }],
          [{ value: 100, isDominant: false, color: 'gray' }],
        ],
      },
    ];
  }

  ngOnChanges(changes: SimpleChanges) {
    this.isDataSumZero = false;
    // Reset state when inputs change to prevent stale data
    this.tabData = this.getDefaultTabData();
    this.riskFlags = [...RISK_FLAGS];
    this.isLoading = true;

    // Guard: only process if data is available
    if (!this.data?.therapeuticArea) {
      return;
    }

    this.isMvpValidData =
      this.data.therapeuticArea.id === 'BBU' &&
      this.elementName === 'Assessing Risk';
    this.loadData();

    //remove after data for other TAs is available
    if (!this.isMvpValidData) {
      this.riskFlags = this.riskFlags.map((flag) => {
        return { ...flag, description: 'No data' };
      });
    }
  }

  loadData() {
    if (this.isMvpValidData) {
      this.tabData[0].progressBars[0] = this.percentageToProgressBar(
        this.percentageSum,
      );
    }

    this.isLoading = false;
  }

  percentageToProgressBar(perc: VendorFlagsPercentages) {
    //check if every value is 0, if so return default progress bar
    if (perc.high === 0 && perc.medium === 0 && perc.low === 0) {
      this.isDataSumZero = true;
      return [{ value: 100, isDominant: false, color: 'gray' }];
    }

    const vals = [
      { value: perc.high, isDominant: false, color: 'red' },
      { value: perc.medium, isDominant: false, color: 'yellow' },
      { value: perc.low, isDominant: false, color: 'green' },
    ];

    //find dominant value
    let maxVal = 0;
    let maxIndex = 0;
    vals.forEach((val, index) => {
      if (val.value > maxVal) {
        maxVal = val.value;
        maxIndex = index;
      }
    });
    vals[maxIndex].isDominant = true;

    return vals;
  }

  getDescriptionForFlag(flag: any, elementName: string): string {
    if (elementName !== 'ABAC') return 'No data available';

    return this.isDataSumZero ? 'No data available' : flag.description;
  }
}
